import React, { JSX } from 'react';

import { CruiseLineProvider } from '~/components/Cruises/context/useCruiseLines';

import { CruiseLineList } from './components/CruiseLineList';

function ShipsPage(): JSX.Element {
  return (
    <CruiseLineProvider>
      <CruiseLineList />
    </CruiseLineProvider>
  );
}

export default ShipsPage;
